import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.js';
import { auth } from '../api/client.js';

export function TotpVerifyPage() {
  const navigate = useNavigate();
  const { setNeedsTotpValidation, logout } = useAuth();
  const [token, setToken] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleVerify = async (e: React.FormEvent) => {
    e.preventDefault();
    if (token.length !== 6) return;
    setLoading(true);
    setError('');
    try {
      await auth.totpValidate(token);
      console.log('[totp] login validated');
      setNeedsTotpValidation(false);
      navigate('/', { replace: true });
    } catch (err) {
      console.error('[totp] validation failed:', err);
      setError('Invalid code. Please try again.');
      setToken('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card" style={{ maxWidth: 400 }}>
        <div className="brand" style={{ justifyContent: 'center', marginBottom: 24 }}>
          <div className="brand-mark" />
          <span className="brand-name">SubFi Pay</span>
        </div>

        <h1 className="login-title">Two-factor authentication</h1>
        <p className="login-subtitle">
          Enter the 6-digit code from your authenticator app.
        </p>

        <form onSubmit={(e) => void handleVerify(e)} className="totp-form">
          <input
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength={6}
            value={token}
            onChange={(e) => setToken(e.target.value.replace(/\D/g, ''))}
            placeholder="000000"
            className="form-input totp-input"
            autoFocus
          />
          <button
            type="submit"
            className="btn-sm btn-primary"
            style={{ width: '100%', padding: '12px', fontSize: 14 }}
            disabled={loading || token.length !== 6}
          >
            {loading ? 'Verifying...' : 'Verify'}
          </button>
        </form>

        {error && <div className="form-error">{error}</div>}

        <button
          className="btn-sm btn-ghost"
          style={{ width: '100%', marginTop: 12, fontSize: 13 }}
          onClick={() => void logout()}
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
